<div class="space-y-3">
  <p class="text-sm text-slate-500">Confirm the inputs and generated outputs before saving.</p>

  @if (status(); as s) {
    <p class="inline-block rounded bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-700" role="status">
      {{ s === 'GENERATED' ? 'CI generated' : 'Saved as draft' }}
    </p>
  }

  @if (calculating()) {
    <p class="text-sm text-slate-500" role="status">Calculating…</p>
  } @else if (calculationError()) {
    <p class="text-sm text-red-600" role="alert">{{ calculationError() }}</p>
  } @else if (!result()) {
    <p class="text-sm text-slate-500">Results appear here once the calculation completes.</p>
  }

  @if (issues().length) {
    <ul class="list-disc space-y-1 rounded-lg border border-amber-200 bg-amber-50 py-3 pl-8 pr-4 text-sm text-amber-800" role="alert">
      @for (issue of issues(); track issue) {
        <li>{{ issue }}</li>
      }
    </ul>
  }

  <dl class="divide-y divide-slate-200 mt-10" [class.opacity-60]="calculating()">
    @for (row of summaryRows(); track row.label) {
      <div class="flex items-baseline justify-between gap-4 py-3">
        <dt class="text-sm text-slate-500">{{ row.label }}</dt>
        <dd class="text-sm font-semibold tabular-nums text-slate-900">{{ row.value }}</dd>
      </div>
    }
  </dl>
</div>
